import { PasswordChangeComponent } from '../../../../shared/components/password-change/password-change.component';
import { LoginService, PasswordResetError } from '../../services/login.service';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { markAllControlsAsDirty } from '@ppl/utils/form.utils';
import { KEYCODE_ENTER } from '@ppl/utils/keycode.utils';
import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import type { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'ppl-new-password',
    templateUrl: './new-password.component.html',
    styleUrls: ['./new-password.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NewPasswordComponent {
  resetting$ = new BehaviorSubject<boolean>(false);
  error$ = new BehaviorSubject<PasswordResetError>(PasswordResetError.NO_ERROR);
  PasswordResetError = PasswordResetError;

  form: UntypedFormGroup;
  hash: string;

  constructor(
    private loginService: LoginService,
    private route: ActivatedRoute
  ) {
    this.form = this.createForm();
    this.hash = this.route.snapshot.paramMap.get('hash');
  }

  createForm() {
    const form = PasswordChangeComponent.createPasswordForm();
    return form;
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.which === KEYCODE_ENTER && this.form.valid) {
      this.onChangePassword();
    }
  }

  onChangePassword() {
    this.error$.next(PasswordResetError.NO_ERROR);
    if (this.form.valid) {
      this.resetting$.next(true);
      const { password1 } = this.form.value;
      this.loginService.passwordReset(this.hash, password1)
        .pipe(
          finalize(() => this.resetting$.next(false))
        )
        .subscribe({
          error: (error: PasswordResetError) => {
            this.error$.next(error);
          }
        });
    } else {
      markAllControlsAsDirty(this.form);
    }
  }
}
